import {
  FETCH_CONTENT_DATA_ERROR,
  FETCH_CONTENT_DATA_INIT,
  FETCH_CONTENT_DATA_SUCCESS,
} from 'containers/Player/actions/content/constants';
import { CLEAR_PLAYER_DATA } from '../actions/player/constants';

const initialState = {
  loading: null,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTENT_DATA_INIT:
      return { ...state, loading: true, data: null, error: null };
    case FETCH_CONTENT_DATA_SUCCESS:
      return { ...state, loading: false, data: action.data, error: null };
    case FETCH_CONTENT_DATA_ERROR:
      return { ...state, loading: false, data: null, error: action.error };
    case CLEAR_PLAYER_DATA:
      return initialState;
    default:
      return state;
  }
};
